import { AnalysisCohort, AddCohortRequest } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { CreateCohortFormData } from '../../types/forms.type';
import { AdapterInterface } from '../../types/global';

import BaseAdapter from './baseAdapter';

export default class PostAddAnalysisCohort extends BaseAdapter<AnalysisCohort> implements AdapterInterface {
  rawResponse: AnalysisCohort;

  modifiedRequest: AddCohortRequest;

  async adaptResponse(request: CreateCohortFormData): Promise<AnalysisCohort> {
    const formattedRequest = this.adaptRequest(request);

    await this.fetchApiResponse('/api/add-cohort', HTTPMethod.Post, formattedRequest);

    return this.rawResponse;
  }

  adaptRequest(request: CreateCohortFormData): AddCohortRequest {
    this.modifiedRequest = {
      cohort_name: request.name,
      tags: request.tags,
      household_references: request.selectedHouseholds,
      scope: {
        start_snapshot: request.startSnapshot,
        end_snapshot: request.endSnapshot,
      },
    };
    return this.modifiedRequest;
  }
}
